import { Button, Tooltip } from "@fluentui/react-components";
import { FC, ReactElement, useEffect, useRef, useState } from "react";
import { Clipboard16Regular, Checkmark16Filled } from '@fluentui/react-icons';
import './CodeSection.scss';

interface CodeSectionProps {
    children: string | number | boolean | ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null;
    className?: string;
}

const CodeSection: FC<CodeSectionProps> = ({ children, className }) => {
    const codeRef = useRef<HTMLElement>(null);
    const [copied, setCopied] = useState<boolean>(false);
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        if (copied) {
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
    }, [copied]);

    return <code ref={codeRef} className={String(className)} onMouseOver={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
        {children}
        {
            hovered && <Tooltip content={'Copy code'} relationship="label">
                <Button
                    className='codeCopyButton'
                    size='medium'
                    icon={copied ? <Checkmark16Filled /> : <Clipboard16Regular />}
                    appearance='transparent'
                    shape='circular'
                    onClick={() => {
                        const codeContent = codeRef.current?.innerText ?? '';
                        navigator.clipboard.writeText(codeContent);
                        setCopied(true);
                    }}
                />
            </Tooltip>
        }
    </code>;
}

export default CodeSection;
